import type { FaireProductEntity } from "../../entity_types/product";

export const p_aev5nadvgm: FaireProductEntity = {
  token: "p_aev5nadvgm",
  type: "product",
  name: "Umami Dashi Soy Sauce - Barrel Aged, Less Sodium, 5oz",
  brandToken: "b_9ys7k5bec7",
  brandName: "Cabi",
  imageUrl:
    "https://cdn.faire.com/fastly/8677fc2feec92cb98774e33a17e661108ba374ad8ba653bb54cd81c3b037af9a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce0b5b31bf8cec6269ae093d33248269a24b68b074e9987ae1d5ac8ed2452d83.png",
    "https://cdn.faire.com/fastly/308b560315e6d7142b4fc29b658a14f8913697aa02d785d044b47e775d16a8e8.png",
    "https://cdn.faire.com/fastly/2ba9f459061b058db5dab77e00417e81aac614a755c3957102406e36ba10fc20.png",
    "https://cdn.faire.com/fastly/7bad774396d66bfc2c1057bc51803ed06ac6aa32b43138aea31fc64ffa6f97a4.jpeg",
  ],
  priceDollars: 6.7,
  description:
    "All crafted in Japan. Barrel-aged. \n★ Less Sodium, Non-GMO Savory Japanese Soy Sauce – Barrel Aged Authentic Japanese Koji Fermented Food Sauce – Versatile Broth Based All Purpose Soy Sauce ★\n\nDashi is a umami packed flavor bomb. It’s also the backbone of most Japanese dishes. With the versatile flavors of dashi and soy sauce weaved together, a heavenly savory flavor and new staple is created! \n\nLess Sodium: Abundant umami ensures no flavor loss, minus high sodium.  \n\nBarrel-Aged Fermentation: Aged in wooden soy sauce barrels, imparts depth and complexity, elevating dishes with rich umami and a symphony of nuanced flavors. \n\nUse it as a broth/soup base by adding water for noodles/ramen even as a pasta sauce or as more flavorful, low-sodium soy sauce replacement, or as dipping sauce. Also, use it as a dressing mixed with olive oil, BBQ sauce to marinate the meat or fish, and steak sauce.\n\nMade in Japan and brought straight from producers who've honed their craft for generations. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:55.798Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
